import React, { useEffect, useCallback } from "react";
import { Container, Table, Col, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchBudgetOnly } from "../../Redux/budgetReduce";


function DetailBudget({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    const location = useParams();
    const [entities, setEntities] = React.useState([]);
    const [tete, setEntitieTete] = React.useState([]);
    const [loader, setLoader] = React.useState(true);

    const getBudget = useCallback(
        async () => {
            var PrixProd = await dispatch(fetchBudgetOnly({ id: location.id }));
            var findBudget = await PrixProd.payload.arrayPrixProd;
            var tableRows = findBudget.map((element, key) => (
                <tr key={"pp" + key}>
                    <td>{element.Designation}</td>
                    <td>{element.code}</td>
                    <td>{element.valeur}</td>

                    <td>{element.janv ?? 0}</td>
                    <td>{element.fev ?? 0}</td>
                    <td>{element.mars ?? 0}</td>
                    <td>{element.avr ?? 0}</td>
                    <td>{element.mai ?? 0}</td>
                    <td>{element.juin ?? 0}</td>
                    <td>{element.juillet ?? 0}</td>
                    <td>{element.aout ?? 0}</td>
                    <td>{element.sept ?? 0}</td>
                    <td>{element.oct ?? 0}</td>
                    <td>{element.nov ?? 0}</td>
                    <td>{element.dec ?? 0}</td>
                    <td>{element.total}</td>
                </tr>

            ));
            setEntities(tableRows);
            setLoader(false)
        },
        [dispatch, location.id]
    );


    const getentete = useCallback(
        async () => {
            var entete = await dispatch(fetchBudgetOnly({ id: location.id }));
            var findentete = await entete.payload.findEntete;
            var tableRows = findentete.map((element, key) => (
                <Table bordered hover style={{ textAlign: "center" }}>
                    <thead >
                        <tr>
                            <th>Nom file</th>
                            <th>Mois</th>
                            <th>Année</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{element.filename}</td>
                            <td>{element.mois}</td>
                            <td>{element.annee}</td>
                        </tr>
                    </tbody>
                </Table>

            ));
            setEntitieTete(tableRows);
        },
        [dispatch, location.id]
    );

    useEffect(() => {
        getBudget();
        getentete();
    }, [getBudget, getentete]);



    function listepp() {
        navigate.push(client + "/listBudget");
    }

    return (
        <>


            <Container fluid>

                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        onClick={listepp}
                    >
                        <span className="btn-label">
                            <i className="fas fa-list"></i>
                        </span>
                        Retour à la liste
                    </Button>
                </Col>
                {loader ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <div>
                        {tete}

                        <hr style={{ borderTop: "4px solid black" }}></hr>

                        <Table bordered hover>
                            <thead className="entete_detail">
                                <tr>
                                    <th>Designation</th>
                                    <th>Code</th>
                                    <th>PG HT</th>

                                    <th>Janv</th>
                                    <th>Fév</th>
                                    <th>Mars</th>
                                    <th>Avr</th>
                                    <th>Mai</th>
                                    <th>Juin</th>
                                    <th>Juil</th>
                                    <th>Août</th>
                                    <th>Sept</th>
                                    <th>Oct</th>
                                    <th>Nov</th>
                                    <th>Déc</th>

                                    <th>Total</th>

                                </tr>
                            </thead>
                            <tbody>{entities}</tbody>
                        </Table>
                    </div>)}
            </Container>
        </>
    );
}

export default DetailBudget;
